import React from 'react';
import useGame from '../../modules/game/hooks/use-game';

import './style.scss';
import Clock from '../../components/clock';
import TrackLink from './track-link';
import { useLocation } from 'react-router';
import ScrollToMe from '../../utils/scroll-to-me';
import { useIsConferenceOver } from '../../modules/game/hooks/use-is-conference-over';

export default function StartPage() {

    const { game, error, isLoading } = useGame();

    const { state } = useLocation<{ scrollToTracks: boolean }>()
    const isConferenceOver = useIsConferenceOver();

    const scrollToTrack = state?.scrollToTracks;

    return (
        <>
            <header>
                <div className="page-container">
                    <aside style={{ position: 'relative' }}>
                        <Clock />
                    </aside>
                    <h1><span>Witaj w grze!</span></h1>
                </div>
            </header>
            <main className='start-page'>
                <div className='page-container column'>


                    {/* <div className="video-container" style={{ maxWidth: '100%' }}>
                        <VimeoPlayer videoId={428964923} autoplay={false} />
                    </div> */}
                    <div className="rules">
                        <p>Twoim zadaniem jest zidentyfikowanie każdej z pięciu nagranych placówek edukacyjnych. Obejrzyj filmy, podejmij decyzję i sprawdź swoją spostrzegawczość!</p>
                        <ol>
                            <li>Wybierz dowolną ścieżkę - oznaczoną grafiką poniżej.</li>
                            <li>Obejrzyj krótkie wideo.</li>
                            <li>Po zakończeniu wideo, za pomocą przycisków, znajdujących się poniżej odtwarzacza, podejmij decyzję, w którą stronę chcesz dalej “pójść”.</li>
                            <li>Zapoznaj się z opisami szkół, które wzięły udział w V edycji konkursu Najlepsze szkolne i przedszkolne przestrzenie uczenia się w Warszawie, znajdującymi się na dole strony.</li>
                            <li>Na otwartym widoku opisu każdej z placówek, znajduje się przycisk “to ta szkoła!”. Jeżeli uważasz, że wybrana przez Ciebie szkoła odpowiada tej przedstawionej na wideo, kliknij ten przycisk.</li>
                            <li>Masz trzy szanse na odpowiedź przy każdej z nagranych placówek.</li>
                            <li>Spróbuj zidentyfikować wszystkie pięć placówek.</li>
                            {!isConferenceOver &&
                                <li><strong>Na odgadnięcie wszystkich pięciu placówek masz 30 minut.</strong></li>
                            }
                        </ol>
                        <p className='lets-go'>Miłej zabawy!</p>
                    </div>

                    {scrollToTrack && <ScrollToMe />}
                    <nav id="sciezki" className="row track-list">
                        {isLoading && <p>ŁADOWANIE...........</p>}
                        {
                            game && <>
                                {game.tracks.map((t, index) => <div className='row' key={index}><TrackLink track={t} /></div>)}
                            </>
                        }
                        {error && <p>Wystąpił błąd: {error}</p>}
                    </nav>
                </div>
            </main>
        </>
    )
}
